import React from "react"
import styles from "./index.module.scss"

import {
  LineShareButton,
  LineIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  PocketShareButton,
  PocketIcon,
} from "react-share"

const SnsShare = props => {
  const { title, url } = props
  const size = 32
  return (
    <div uk-grid="true" style={{ margin: "0" }}>
      <FacebookShareButton url={url} className={styles.sharebutton}>
        <FacebookIcon size={size} borderRadius={10} />
      </FacebookShareButton>

      <TwitterShareButton
        title={title}
        via="@jackjasonb"
        url={url}
        className={styles.sharebutton}
      >
        <TwitterIcon size={size} borderRadius={10} />
      </TwitterShareButton>

      <LineShareButton title={title} url={url} className={styles.sharebutton}>
        <LineIcon size={size} borderRadius={10} />
      </LineShareButton>

      <PocketShareButton title={title} url={url} className={styles.sharebutton}>
        <PocketIcon size={size} borderRadius={10} />
      </PocketShareButton>
    </div>
  )
}

export default SnsShare
